import { TMedInstitutionState, TMedInstitutionsActions } from '../../types/medical-institutions';

export const medInstitutionsActionTypes = {
  GET_INSTITUTIONS_REQUEST: 'MED_INSTITUIONS/GET_INSTITUTIONS_REQUEST',
  GET_INSTITUTIONS_SUCCESS: 'MED_INSTITUIONS/GET_INSTITUTIONS_SUCCESS',
} as const;

const initialState: TMedInstitutionState = {
  institutions: [],
};

export default (
  state: TMedInstitutionState = initialState,
  action: TMedInstitutionsActions,
): TMedInstitutionState => {
  switch (action.type) {
    case medInstitutionsActionTypes.GET_INSTITUTIONS_SUCCESS:
      return {
        ...state,
        institutions: action.payload,
      };

    default:
      return state;
  }
};

export const actions = {
  getMedInstitutionsRequest: () => ({ type: medInstitutionsActionTypes.GET_INSTITUTIONS_REQUEST }),
};
